export default __webpack_public_path__ + "static/media/buster_klein_3.1fae9450.jpg";